import { Injectable, EventEmitter } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  public pageView(url: string) {
    // setTimeout(() => {
    //   gtag('config', 'UA-172855854-1', {'page_path': url});
    // }, 1000);  // anti-bot timeouts; don't want hit reports from bounced bots.
  }

  public event(eventName: string,
               eventCategory: string,
               eventAction: string,
               eventLabel?: string,
               eventValue?: number) {
    setTimeout(() => {
      // gtag('event', eventName, {
      //      'event_category': eventCategory,
      //      'event_label': eventLabel,
      //      'event_value': eventValue
      //     });
    }, 1000);  // anti-bot timeouts; don't want hit reports from bounced bots.
  }
}
